import ApiService from '@/services/api.service'

const AuditService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: "/WebAudits/",
            headers: {
            },
            params: parameter
        }
        return ApiService.customRequest(requestData);
    },

    getHistory(recId) {
        return ApiService.get(`/WebAudits/History/?recId=${recId}`);  
    }
}

export default AuditService;